import React, { ReactElement } from 'react';
import { MenuItem, Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';

export interface MenuItem {
  label: string;
  icon?: ReactElement;
  onClick?: () => void;
  'data-testid'?: string;
}

interface MenuProps {
  items: MenuItem[];
}

export const Menu = (props: MenuProps & MuiMenuProps) => {
  const { items, ...rest } = props;
  return (
    <MuiMenu {...rest}>
      {items.map((item, index) => (
        <MenuItem key={index} onClick={item.onClick} data-testid={item['data-testid']}>
          {item.label}
        </MenuItem>
      ))}
    </MuiMenu>
  );
};
